<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <component :is="el.tag" v-for="(el, i) in icons[name]" :key="i" v-bind="elAttrs(el)" />
  </svg>
</template>

<script setup lang="ts">
import { icons } from '@/ui/icons.js';

defineProps({
  name: { required: true, type: String },
  size: { default: 20, type: Number },
});

function elAttrs({ tag: _tag, ...rest }) {
  return rest;
}
</script>
